<div>
    <fieldset>
        <legend>Organizing Committee Details</legend>
        <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3">
            <div>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Organizer Name</mat-label>
                    <input matInput formControlName="categoryname" type="text">
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Organizer Phone No.</mat-label>
                    <input matInput formControlName="categoryname" type="number">
                </mat-form-field>
            </div>
        </div>
    </fieldset>

    <fieldset>
        <legend>Training Details</legend>
        <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 gap-x-3">
            <div>
                <!-- <mat-form-field appearance="outline">
                    <mat-label>Category</mat-label>
                    <mat-select>
                        <mat-option value="yes">Category-1</mat-option>
                        <mat-option value="no">Category-2</mat-option>
                    </mat-select>
                </mat-form-field> -->
                <app-training-theme-selection-list [label]="'Local Label'" [popup-size]="'Large'" [mandatory]="true" />
            </div>
            <!-- <div>
                <mat-form-field appearance="outline">
                    <mat-label>Sub Category</mat-label>
                    <mat-select>
                        <mat-option value="yes">Sub Category-1</mat-option>
                        <mat-option value="no">Sub Category-2</mat-option>
                    </mat-select>
                </mat-form-field>
            </div> -->
            <div>
                <!-- <mat-form-field appearance="outline">
                    <mat-label>Training Name</mat-label>
                    <mat-select>
                        <mat-option value="yes">Training Name-1</mat-option>
                        <mat-option value="no">Training Name-2</mat-option>
                    </mat-select>
                </mat-form-field> -->
                <app-training-selection-list [label]="'Local Label'" [popup-size]="'Large'"
                    [mandatory]="true"></app-training-selection-list>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Training Venue</mat-label>
                    <mat-select>
                        <mat-option value="yes">Training Venue-1</mat-option>
                        <mat-option value="no">Training Venue-2</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>Start Date</mat-label>
                    <input matInput [matDatepicker]="pickerStart">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerStart"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStart></mat-datepicker>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field appearance="outline">
                    <mat-label>End Date</mat-label>
                    <input matInput [matDatepicker]="pickerEnd">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEnd></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <fieldset>
            <table class="table-auto budget-table mt-2">

                <tbody>
                    <tr>
                        <td class="w-25 bg-sky">Budget Head</td>
                        <td class="w-25">B.2.3.5</td>
                        <td class="w-25 bg-sky">Mode of Training</td>
                        <td class="w-25">Residential</td>
                    </tr>
                    <tr>
                        <td class="w-25 bg-sky">Type of Participants</td>
                        <td class="w-25 bg-yellow">New</td>
                        <td class="w-25 bg-sky">Duration</td>
                        <td class="w-25 bg-yellow">2 Days</td>
                    </tr>

                    <tr>
                        <td class="w-25 bg-sky">Training KIT</td>
                        <td class="w-25 bg-yellow">Yes <a class="font-semibold text-sky-500">( Click Here )</a></td>
                        <td class="w-25 bg-sky">Training Materials / Handout</td>
                        <td class="w-25 bg-yellow">Yes <a class="font-semibold text-sky-500">( Click Here )</a></td>
                    </tr>
                    <tr>
                        <td class="w-25 bg-sky">Refreshment Needed</td>
                        <td class="w-25 bg-yellow" colspan="3"> Yes </td>
                    </tr>
                </tbody>
            </table>
        </fieldset>
    </fieldset>

    <fieldset class="mt-3">
        <legend>Resource Persons / Trainer Details</legend>
        <div class="mt-3">
            <table class="table-auto budget-table mt-2">
                <thead>
                    <tr>
                        <th>Sl. No.</th>
                        <th>Designation</th>
                        <th>Trainer</th>
                        <th>Phone No.</th>
                        <th>Honorarium</th>
                        <th>TA</th>
                        <th>Remove</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>1</td>
                        <td>BLT</td>
                        <td>AJAY DUTTA</td>
                        <td>8923665336</td>
                        <td>800</td>
                        <td>500</td>
                        <td>
                            <span class="material-symbols-outlined">delete</span>
                        </td>
                    </tr>

                    <tr>
                        <td>2</td>
                        <td>SLT</td>
                        <td>AMIT DEY</td>
                        <td>8923665336</td>
                        <td>750</td>
                        <td>0</td>
                        <td>
                            <span class="material-symbols-outlined">delete</span>
                        </td>
                    </tr>

                    <tr>
                        <td>3</td>
                        <td>SLT</td>
                        <td>SUMIT DAS</td>
                        <td>8923665336</td>
                        <td>750</td>
                        <td>0</td>
                        <td>
                            <span class="material-symbols-outlined">delete</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </fieldset>


    <fieldset class="mt-3">
        <legend>Participants Details</legend>
        <div class="mt-3">
            <table class="table-auto budget-table mt-2">
                <thead>
                    <tr>
                        <th>Sl. No.</th>
                        <th>CBO Type</th>
                        <th>GP</th>
                        <th>Village</th>
                        <th class="w-48">CBO Name</th>
                        <th>Participants No.</th>
                        <th>Remove</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>1</td>
                        <td>CBO-1</td>
                        <td>GP-1</td>
                        <td>Village-1</td>
                        <td class="w-48">ABC SHG</td>
                        <td>3</td>
                        <td>
                            <span class="material-symbols-outlined">delete</span>
                        </td>
                    </tr>
                    <tr>
                        <td>2</td>
                        <td>CBO-1</td>
                        <td>GP-5</td>
                        <td>Village-3</td>
                        <td class="w-48">XYZ SHG</td>
                        <td>3</td>
                        <td>
                            <span class="material-symbols-outlined">delete</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-3">
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Status</mat-label>
                <mat-select>
                    <mat-option value="Approved">Approved</mat-option>
                    <mat-option value="Reject">Reject</mat-option>
                    <mat-option value="Revert Back">Revert Back</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Remarks</mat-label>
                <textarea matInput placeholder="Enter remarks..." rows="3"></textarea>
            </mat-form-field>
        </div>
        <div class="flex justify-end mt-3">
            <button type="submit" class="btn-action-save">
                <span class="material-symbols-outlined">save</span>
                Save
            </button>
        </div>

    </fieldset>
</div>